import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
export function ContactCTASection() {
  const {
    t
  } = useLanguage();
  const benefits = t.contactCta.benefits;
  return <section className="w-full bg-[#1e456b] py-20 border-b border-white/10" data-id="element-15">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-16">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10" data-id="element-17">
          {/* Left Content */}
          <div className="max-w-2xl" data-id="element-18">
            <h2 className="text-3xl lg:text-4xl font-poppins font-bold text-white mb-4" data-id="element-19">
              {t.common.howCanWeHelp}
            </h2>
            <p className="text-blue-100 text-lg mb-8" data-id="element-20">{t.common.ctaSubtitle}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-21">
              {benefits.map((benefit, index) => <div key={index} className="flex items-center gap-3" data-id="element-22">
                  <CheckCircle2 className="w-5 h-5 text-brandOrange shrink-0" data-id="element-23" />
                  <span className="text-white text-sm font-medium" data-id="element-24">
                    {benefit}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Right Content - CTA Button */}
          <div className="shrink-0" data-id="element-25">
            <Link to="/contact" className="bg-brandOrange hover:bg-brandOrange-hover text-white px-8 py-4 rounded font-semibold flex items-center gap-2 transition-colors text-base shadow-lg shadow-brandOrange/20" data-id="element-26">
              {t.common.requestConsulting}
              <ArrowRight className="w-5 h-5" data-id="element-27" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}